let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fModo")).then(() => parcelRequire('1HB7W'));